import { useEffect, useRef } from 'react'

import { MissionTriggerModel } from '../../../domain/model/mission-trigger.model'
import { usePage } from '../../contexts'
import { getLocalStorage } from '../../utils/storage_helpers'
import { SoundBox } from './styles'
import Feedback from './feedback'
import Popup from './popup'
import { t } from '../../adapters/translate/translate'

type IAction = {
  action: () => void;
}

type Props = {
  missionTrigger: MissionTriggerModel;
  isShowing: boolean;
  action?: IAction;
}

const MissionTrigger = ({ missionTrigger, isShowing, action = { action: () => {} } }: Props) => {
  const { soundActivated } = usePage()
  const audio:any = useRef()

  function getCurrentTriggerComponent () {
    switch (missionTrigger.showAs) {
      case 'feedback': return <Feedback isShowing={isShowing} missionTrigger={missionTrigger} action={action}/>
      case 'popup': return <Popup isShowing={isShowing} missionTrigger={missionTrigger}/>
      default: return <Feedback isShowing={isShowing} missionTrigger={missionTrigger} action={action}/>
    }
  }

  useEffect(() => {
    const soundIsActivated = JSON.parse(getLocalStorage('soundIsActivated') ?? 'false')

    if (isShowing && soundIsActivated && audio.current) {
      const currentAudio = audio.current

      currentAudio.pause()
      currentAudio.load()

      const playPromise = currentAudio.play()

      if (playPromise) {
        playPromise.then(() => {
          setTimeout(() => {
            if (currentAudio) {
              currentAudio.pause()
            }
          }, 5000)
        }).catch((error: any) => {
          console.error('Error playing audio:', error)
        })
      }
    }

    return () => {
      if (audio.current) {
        audio.current.pause()
      }
    }
  }, [isShowing, missionTrigger, soundActivated])

  return (
    <>
    {!!missionTrigger.sound && (
      <SoundBox>
        <audio ref={audio} autoPlay={false} controls>
          <source src={missionTrigger.sound} type="audio/mp3" />
          {t("Your browser don't support HTML5")}
        </audio>
      </SoundBox>
    )}
    {getCurrentTriggerComponent()}
    </>
  )
}

export default MissionTrigger
